import {
  REQUEST_AUTH_DATA,
  RECEIVE_AUTH_DATA,
  RESET_AUTH_DATA,
  RECEIVE_ACCESSIBLE_ACCOUNTS,
  SET_CURRENT_ACCOUNT
} from "../../actions/types";

const initialState = {
  authUser: null,
  accessibleAccounts: [],
  updatedAt: null,
  currentAccountId: null,
  isFetching: false
}

const requestAuthData = (state) => ({...state, isFetching: true})
const receiveAuthData = (state, {user,account}) => {
  const accessibleAccounts = state.accessibleAccounts.slice()
  if(accessibleAccounts.findIndex(a => a.id == account.id)<0) {
    accessibleAccounts.push(account)
  }

  return {
    authUser: user,
    accessibleAccounts,
    updatedAt: Date.now(),
    currentAccountId: account.id,
    isFetching: false
  }
}

const resetAuthData = () => ({...initialState})

const receiveAccessibleAccounts = (state, {updates}) => {
  const accessibleAccounts = state.accessibleAccounts.slice()

  updates.added.forEach(n => {
    if(accessibleAccounts.findIndex(o => o.id === n.id)<0) {
      accessibleAccounts.push(n)
    }
  })

  updates.modified.forEach(m => {
    const index = accessibleAccounts.findIndex(o => o.id === m.id)
    accessibleAccounts[index] = {...m}
  })
  updates.removed.forEach(r => {
    const index = accessibleAccounts.findIndex(o => o.id === r.id)
    accessibleAccounts.splice(index,1)
  })

  return {...state, accessibleAccounts}
}


const setCurrentAccount = (state,{id}) => ({...state, currentAccountId: id})

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_AUTH_DATA: return requestAuthData(state,action)
    case RECEIVE_AUTH_DATA: return receiveAuthData(state,action)
    case RESET_AUTH_DATA: return resetAuthData(state,action)
    case RECEIVE_ACCESSIBLE_ACCOUNTS: return receiveAccessibleAccounts(state,action)
    case SET_CURRENT_ACCOUNT: return setCurrentAccount(state,action)
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/redux/reducers/account.js